module.exports = __webpack_public_path__ + "img/banner.d2721ea9.png";